import React from 'react';
import { blogPosts } from '../data/mockData';
import { Clock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Insights = () => {
  return (
    <section id="insights" className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            Insights & Perspectives
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Operational intelligence on hospitality hiring, workforce risk, and stability-focused recruitment.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {blogPosts.map((post) => (
            <article 
              key={post.id}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:border-[#FFD000] transition-all duration-300 group cursor-pointer"
            >
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <span className="bg-[#FFD000]/10 text-[#FFD000] px-3 py-1 rounded-full text-xs font-semibold">
                    {post.category}
                  </span>
                  <div className="flex items-center text-gray-500 text-xs">
                    <Clock className="h-4 w-4 mr-1" />
                    {post.readTime}
                  </div>
                </div>

                <h3 className="text-lg font-normal text-black mb-2 group-hover:text-[#FFD000] transition-colors duration-300">
                  {post.title}
                </h3>

                <p className="text-gray-700 text-sm leading-relaxed mb-4">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-end">
                  <Button 
                    variant="ghost"
                    className="text-[#FFD000] hover:text-[#FFD000] hover:bg-[#FFD000]/10 p-0 text-sm"
                  >
                    Read More
                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
                  </Button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Button 
            variant="outline"
            className="border-2 border-[#FFD000] text-[#FFD000] hover:bg-[#FFD000] hover:text-black text-sm"
          >
            View All Insights
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Insights;
